<template>
  <div>
    <div class="approved">
      <div class="approved-content">
        <div v-if="status===2||status===4">
          <!-- // 审核通过 -->
          <div class="approved-content-title">
            <div><span class="medium">Brand: </span><span>{{message.brandName}}</span></div>
            <div>{{message.createAt}}</div>
          </div>
          <div class="approved-content-text">
            <div>The Service Order has been approved and the refund is pending</div>
          </div>
        </div>
        <div v-if="status===60||status===61">
          <!-- // 审核拒绝 -->
          <div class="approved-content-title">
            <div><span class="medium">Brand: </span><span>{{message.brandName}}</span></div>
            <div>{{message.createAt}}</div>
          </div>
          <div class="approved-content-text">
            <div>Refund is denied</div>
            <div>Denial Reason: {{message.reason}}</div>
          </div>
        </div>
        <div  v-if="status===5">
          <!-- 取消 -->
          <div class="approved-content-title">
            <div><span class="medium">Brand: </span><span>{{message.username}}</span></div>
            <div>{{message.createAt}}</div>
          </div>
          <div class="approved-content-text">
            <div>The Retailer ({{message.username}})  cancel order</div>
            <!-- <div>Reason for Cancellationn: 缺少取消原因字端</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// 通过 拒绝 取消
export default {
  name: 'approved',
  props: {
    message: {
      default: () => { return {} },
      type: Object
    },
    status: {
      default: 0,
      type: Number

    }
  },
  created() {
    console.log(this.message)
  }
}
</script>

<style lang="less" scoped>
.approved{
  padding: 20px;
  line-height: 32px;
  .approved-content{
    padding-bottom: 20px;
    border-bottom: 1px solid #e1e1e1;
    .approved-content-title{
      display: flex;
      justify-content: space-between;
    }
  }
}
.medium{
  font-family: Satoshi-medium;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/history-list/approved.vue